export enum ENativeLoadingEvent {
  Show = 'Loading:Show',
  Hide = 'Loading:Hide'
}
